<script setup>
defineProps({
  label: { type: String, required: true },
  modelValue: { type: [String, Number], default: '' },
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex flex-col gap-2">
    <label
      class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-body"
    >
      {{ label }}
    </label>
    <div class="flex max-w-[34rem] flex-wrap gap-2">
      <button
        v-for="option in options"
        :key="option.value || option.label"
        type="button"
        class="inline-flex min-h-9 items-center gap-2 rounded-full border px-3 py-1 text-[12px] font-semibold transition-colors"
        :class="
          modelValue === option.value
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary shadow-sm'
            : 'border-lais-border bg-white text-lais-text-body hover:border-lais-primary hover:text-lais-primary'
        "
        :aria-pressed="modelValue === option.value"
        @click="emit('update:modelValue', option.value)"
      >
        <span
          v-if="option.icon"
          class="size-3.5 shrink-0"
          :class="option.icon"
          aria-hidden="true"
        />
        <span>{{ option.label }}</span>
      </button>
    </div>
  </div>
</template>
